import React from 'react';
import { HighchartsReactRefObject } from 'highcharts-react-official';

import Loading from '../../Loading';
import useFunnelData from './useFunnelData';
import FunnelView from './FunnelView';

const FunnelContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<HighchartsReactRefObject | null>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, isReady } = useFunnelData({
    chartDefinition,
    chartRef,
  });

  if (!isReady) {
    return <Loading />;
  }

  return (
    <FunnelView
      chartRef={chartRef}
      options={options!}
      isNoData={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default FunnelContent;
